import React from 'react'
import { ReactComponent as FlagIcon } from '../../../common/icons/flagBanner.svg'
import { ReactComponent as GearIcon } from '../../../common/icons/gear.svg'
import { ReactComponent as LightbulbIcon } from '../../../common/icons/lightbulb.svg'
import block_2 from '../../../common/images/onboarding/block_2.png'
import block_3 from '../../../common/images/onboarding/block_3.png'
import block_1 from '../../../common/images/onboarding/block_1.png'
import block_4 from '../../../common/images/onboarding/block_4.png'
import { useNavigate } from 'react-router-dom'

export default function useLearnPage() {
  const navigation = useNavigate()
  const config = [
    {
      id: 1,
      blockName: 'Reporting',
      icon: <FlagIcon />,
      content: 'Make Phishing Reporting Effortless – Protect Your Organization in One Click',
      buttonName: 'Install Email Plugin',
      rightSideImage: block_1,
      onClick: () => {
        navigation('/settings/plugins')
      }
    },
    {
      id: 2,
      blockName: 'Automation',
      icon: <GearIcon />,
      content: 'React to Phishing Attacks Automatically – Set Up Instant Security Workflows',
      buttonName: 'Activate Workflow',
      rightSideImage: block_2,
      onClick: () => {
        navigation('/workflows')
      }
    },
    {
      id: 3,
      blockName: 'AI Assistant',
      icon: <LightbulbIcon />,
      content: 'Deliver Personalized Security Training in Slack, Teams & Google Chat – Powered by AI',
      buttonName: ' Install AI Assistant',
      rightSideImage: block_3,
      onClick: () => {
        navigation('/security-assistant')
      }
    },
    {
      id: 4,
      blockName: 'Smart Training',
      icon: <LightbulbIcon />,
      content:
        'Invite employees to an interactive e-learning space to train, track progress, and build security habits through gamification.',
      buttonName: 'Get started',
      rightSideImage: block_4,
      onClick: () => {
        navigation('/training-packages')
      }
    }
  ]

  return { config }
}
